// extracted by mini-css-extract-plugin
export default {"PlaceholderMediaMatch":"PlaceholderMediaMatch--rmr0P","title":"title--wncA7","text":"text--u2T9S"};